import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import groupBy from "lodash/groupBy";

export default class PermissionListPromptController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    const { request = {}, title } = options;

    $ctrl.request = {
      id: request.id,
      label: request.label,
      description: request.description,
      permissions: request.permissions
    };
    $ctrl.action = request.id ? "Update" : "Create";
    $ctrl.title = title || `${$ctrl.action} Permission List...`;
    $ctrl.bus = new ServiceBus();
    $ctrl.bus
      .read("QueryPermissions.json", { orderBy: "GroupName,Name" })
      .then(
        res => ($ctrl.permissions = groupBy(res.data.results, "groupName"))
      );
  }

  $onInit() {
    const $ctrl = this;
  }

  submit() {
    const $ctrl = this;

    $ctrl.bus
      .send(`${$ctrl.action}PermissionList.json`, $ctrl.request)
      .then(r => $ctrl.$close(r.data));
  }
}
